﻿import { Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import classes from "./ordersReturnAction.module.scss";

import { getToday, hasPermission } from "@/services/Utils";

import ButtonFilter from "@/components/Filter/ButtonFilter";

import { FETCHING_ADD_DOWNLOAD } from "@/redux/types/main.types";
import { useOrderReturnPaginate } from "@/hooks/purchases/orders_return";

const OrdersReturnAction = ({ showFilter, setShowFilter, filters }) => {
	const { data } = useOrderReturnPaginate(filters);
	const { permissions } = data;

	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const { filter } = useSelector((state) => state.auth);

	const exportExcel = () => {
		const filename = `${location.pathname.replace("/", "")}  ${getToday()}.xlsx`;

		const params = {
			...filters,
			...filter,
		};

		dispatch({
			type: FETCHING_ADD_DOWNLOAD,
			payload: {
				file: {
					key: Array.from({ length: 25 }, () => Math.random().toString(36)[2] || "0").join(""),
					params: params,
					show: true,
					url: "/client/excel/nota_credito",
					name: filename,
					type: "excel",
					inExecution: false,
					inProgress: false,
					inChecked: false,
				},
			},
		});
	};

	return (
		<Row className={classes.header}>
			<ButtonFilter origin="actions" size_md={1} showFilter={showFilter} setShowFilter={setShowFilter} />

			<Col md={11} style={{ justifyContent: "right", display: "flex" }}>
				{hasPermission("create", permissions) && (
					<div
						className={`${classes.optionButton} ${classes.newInventory}`}
						onClick={() => {
							navigate(`${location.pathname}/ingresar`);
						}}
					>
						<span>Cargar</span>
					</div>
				)}

				<div className={`${classes.optionButton} ${classes.exportInventory}`} onClick={() => exportExcel()}>
					<span>Excel</span>
				</div>
			</Col>
		</Row>
	);
};

export default OrdersReturnAction;
